/**
 * Utility to determine which ingredients should be added to the pantry
 * after confirming an ingredient review in the IngredientReviewSheet.
 *
 * Returns ingredient names that the user checked as "have it"
 * but that are NOT already matched to existing inventory items.
 */
export function getNewPantryItemNamesFromReview(
  ingredients: { name: string; checked: boolean; inInventory: boolean }[]
): string[] {
  return ingredients
    .filter(ing => ing.checked && !ing.inInventory)
    .map(ing => ing.name)
    .filter(name => name.trim().length > 0);
}
